import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { StarLogo } from "../../SibaIcons/index";
import { useState } from "react";
import { growlInfo, userManagementUtil } from "@siba/utilities";
import { ShowWarningConfirmation } from '@siba/components';
import baseUrl from '../../features/services/service';

interface Props {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window?: () => Window;
}

const drawerWidth = 240;
const navItems = [
    { name: 
        userManagementUtil.getUserSession() ? "Logout" :
     "Login", path: "login" },
    { name: "Salvages", path: "salvage" },
    { name: "My Bids", path: "bids" },
    { name: "Register", path: "register" }
];

export default function DrawerAppBar(props: Props) {
    const { window } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };
    const redirect = useNavigate(); //this the re-direct api

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
            <Typography variant="h6" sx={{ my: 2, marginBottom: "20px" }}>
            <img alt={"star assurance"} src={StarLogo} width="160" loading="lazy"/>
            </Typography>
            <Divider style={{marginTop: "20px", marginBottom: "20px"}} />
            <List>
                {navItems.map((item, index) => (
                <ListItem key={item.name} disablePadding>
                    <ListItemButton
                    defaultValue={item.name}
                    sx={{
                        textAlign: "center",
                        border: "1px solid",
                        borderColor: index === navItems.length - 1 ? "#404040" : "#F7001F",
                        padding: "5px 10px",
                        backgroundColor: index === navItems.length - 1 ? "#404040" : "#transparent",
                        color: index === navItems.length - 1 ? "#fff" : "#404040",
                        borderRadius: "60px",
                        marginBottom: "15px",
                        width: "70px",
                        margin: "0px 30px 15px 30px",
                    }}
                    onClick={(e) => {
                        switch (item.name) {
                        case "Logout":
                            ShowWarningConfirmation("Are you sure you want to log out?", () => {
                            userManagementUtil.exitToPath(baseUrl.frontend);
                            });
                            break;
                        default:
                            redirect(item.path);
                            break;
                        }
                    }}
                    >
                    <ListItemText primary={item.name} />
                    </ListItemButton>
                </ListItem>
                ))}

            </List>
        </Box>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box sx={{ display: "flex", marginBottom: "80px" }}>
            <CssBaseline />
            <AppBar component="nav" className="mainNav" sx={{padding: {sm : "0px 15px", md:"0px 40px"}}}>
                <Toolbar>
                    <IconButton color="inherit" aria-label="open drawer" edge="start" onClick={handleDrawerToggle} sx={{ mr: 2, display: { sm: "none" } }}>
                        <MenuIcon fontSize="large" style={{color: "#F7001F"}} />
                    </IconButton>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}>
                        <img alt={"star assurance"} src={StarLogo} width="160" loading="lazy" />
                        {/* {" "}Star Assurance Salvages */}
                    </Typography>
                    <Box sx={{ display: { xs: "none", sm: "block" } }}>
                    {navItems.map((item, index) => (
                    <Button
                        key={item.name}
                        sx={{
                        color: index === navItems.length - 1 ? "#fff" : "#404040",
                        marginLeft: index !== navItems.length - 1 ? "0px" : "40px",
                        backgroundColor: index === navItems.length - 1 ? "#F7001F" : "transparent",
                        borderRadius: index === navItems.length - 1 ? "40px" : "0px",
                        borderBottom: index === selectedIndex ? "4px solid #F7001F" : "none",
                        padding: index === selectedIndex ? "8px 30px" : "8px 30px",
                        // Hover styles for the last button
                        "&:hover": {
                            backgroundColor: index === navItems.length - 1 ? "transparent" : "transparent",
                            border: index === navItems.length - 1 ? "1px solid #F7001F" : "none",
                            color: index === navItems.length - 1 ? "#404040" : "#404040",
                        },
                        }}
                        defaultValue={item.name}
                        onClick={() => {
                            setSelectedIndex(index);
                            switch (item.name) {
                                case "Logout":
                                    ShowWarningConfirmation("Are you sure you want to log out?", () => {
                                        userManagementUtil.exitToPath(baseUrl.frontend);
                                    });
                                    break;
                                default:
                                    redirect(item.path);
                                    break;
                            }
                        }}
                    >
                        {item.name}
                    </Button>
                    ))}

</Box>



                </Toolbar>
            </AppBar>
            <Box component="nav">
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: "block", sm: "none" },
                        "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth }
                    }}
                >
                    {drawer}
                </Drawer>
            </Box>
        </Box>
    );
}
